



























































































import {Vue, Component, Provide} from 'vue-property-decorator';
import CenterPoint from '@/models/centerpoint.ts';

import Paginition from '@/components/Paginition.vue';
import FilterMenu from '@/components/FilterMenu.vue';
import {Filter} from '@/utils/Filter';
import {Utils} from '@/utils/Utils';
import {API} from '@/services/api/api';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {
    ...mapActions(['showSuccessToast', 'showErrorToast']),
  },
  components: {
    Paginition,
    FilterMenu,
  },
})
export default class filteredCenterPoints extends Vue {
  header = [
    {
      value: 'shipName',
      name: 'Ship Name',
      headerType: 'text',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },
    {
      value: 'deckName',
      name: 'Deck Name',
      headerType: 'text',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },
    {
      value: 'centerFrom',
      name: 'Center From',
      headerType: 'number',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },
    {
      value: 'centerUpto',
      name: 'Center Upto',
      headerType: 'number',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },
    {
      value: 'edit',
      name: 'Edit',
      headerType: 'text',
      sortable: false,
      filter: false,
      bindClass: 'text-center',
    },
    {
      value: 'delete',
      name: 'Delete',
      headerType: 'text',
      sortable: false,
      filter: false,
      bindClass: 'text-center',
    },
  ];

  filteredCenterPoints: CenterPoint[] = [];

  centerPointsList: CenterPoint[] = [];

  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point
  curentSort = ''; //current sort on which header

  //Store Variable
  showSuccessToast: any;
  showErrorToast: any;

  //Modal & Loader Variable
  isScreenLoading = false;
  modalVisible = false;
  loadingBtnStatus = false;
  modalConfimationMsg: any = null;
  modalTitle: any = null;

  centerPointId: any = null;
  deleteStatus: any = null;
  asdcOrder = true;

  mounted() {
    this.getCenterPointList();
  }

  //get list from api
  async getCenterPointList() {
    try {
      this.isScreenLoading = true;
      const response = await API.fetchCenterPointList();
      if (response.data) {
        const data = response.data;
        this.modifyData(data);
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  // modify list with respect to view
  modifyData(centerPointData: []) {
    const result: CenterPoint[] = centerPointData.map((x: any) => {
      return {
        id: x.id,
        deckName: x.deck.name,
        shipName: x.deck.ship.name,
        centerFrom: x.centerFrom,
        centerUpto: x.centerUpto,
      };
    });

    this.centerPointsList = result;
    this.filteredCenterPoints = this.centerPointsList;
  }
  //sorting list
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredCenterPoints);
    this.asdcOrder = sorted;
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }

  //filter data based upon string parameters
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.centerPointsList);
    this.filteredCenterPoints = filteredData;
    this.resetPagination();
  }

  //filter data based upon number parameters
  filterOnNumber(emittedFilterParams: any) {
    let filteredData = Filter.filterOnNumberData(emittedFilterParams, this.centerPointsList);

    this.filteredCenterPoints = filteredData;
    this.resetPagination();
  }

  //reset all filters and show current list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredCenterPoints = this.centerPointsList;
      this.resetPagination();
    }
  }

  //show delete confirmation  modal
  displayDeleteModal(recordId: string) {
    this.centerPointId = recordId;
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure want to delete ?';
    this.deleteStatus = true;
  }

  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  //navigate to create page
  goToCreateCenterPoints() {
    this.$router.push('/create-center-point');
  }

  //navigate to edit page
  editfilteredCenterPoints(pointId: string) {
    this.$router.push({path: 'edit-center-point/' + pointId});
  }

  //handling delete record
  async deleteRecord() {
    try {
      const response = await API.deleteCenterPointById(this.centerPointId);

      if (response.message) {
        this.centerPointsList = this.centerPointsList.filter((center) => center.id != this.centerPointId);
        this.filteredCenterPoints = this.filteredCenterPoints.filter((center) => center.id != this.centerPointId);
        this.showSuccessToast({msg: response.message});
        // this.getCenterPointList();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    }
  }
}
